module.exports = __webpack_public_path__ + "img/loading.118b18fa.svg";